module.exports = __webpack_public_path__ + "img/patient-card-tabs-mobile-en.fae12127.jpg";